// extracted by mini-css-extract-plugin
module.exports = {"markdownA":"YMmbnXHl","markdownTableContainer":"Bwfub3wm","markdownTable":"YV7w0qSK"};